import { PropTypes } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const DamageDetailsContainer = styled.div`
  display: flex;
  font-size: 12px;
  margin-top: ${(props) => (props.component == 'Blade' ? '10px' : '25px')};
  margin-left: 21px;
  padding-bottom: 100px;
`;

const DamageDetailBoxLabelsValues = styled.div`
  flex: 1;
`;

const DamageFieldsLabel = styled.label`
  display: block;
  color: ${(props) => props.theme.themeSelector.customView.inputBorderColor};
  margin-bottom: 4px;
`;
const DamageFieldsValue = styled.p`
  margin: 0 0 18px 0;
`;
const DamageDetailDescription = styled.div`
  flex: 2;
`;
const ReportDamage = styled.div`
  display: grid;
  grid-template-columns: 100px 350px;
  column-gap: 10px;
  margin-bottom: 10px;
`;
const ReportDamageFieldsLabel = styled.label`
  color: ${(props) => props.theme.themeSelector.customView.inputBorderColor};
  text-align: right;
`;
const ReportDamageFieldsValue = styled.p`
  margin: 0;
`;

const DamageDetailPanel = (props) => {
  const { t } = useTranslation(['inspections.damage-details'], {
    useSuspense: false,
  });
  const { damageLabels, damageData, damageLabelValues } = props;

  return (
    <DamageDetailsContainer component={damageLabelValues.component}>
      <DamageDetailBoxLabelsValues>
        {damageLabels.map((label) => (
          <div key={label.access}>
            <DamageFieldsLabel>{t(`damage_labels.${label.access}`, label.label)}</DamageFieldsLabel>
            <DamageFieldsValue>{damageLabelValues[label.access]}</DamageFieldsValue>
          </div>
        ))}
      </DamageDetailBoxLabelsValues>

      <DamageDetailDescription>
        {damageData.map((dData) => {
          return (
            <ReportDamage key={dData.access}>
              <ReportDamageFieldsLabel>{t(dData.access, dData.label)}</ReportDamageFieldsLabel>
              <ReportDamageFieldsValue>{dData.value}</ReportDamageFieldsValue>
            </ReportDamage>
          );
        })}
      </DamageDetailDescription>
    </DamageDetailsContainer>
  );
};

DamageDetailPanel.propTypes = {
  damageLabels: PropTypes.arrayOf(PropTypes.object),
  damageData: PropTypes.arrayOf(PropTypes.object),
  damageLabelValues: PropTypes.object,
};

export default DamageDetailPanel;
